import { AUTH_POPUP_BASE, AUTH_CLIENT_ID, AUTH_REDIRECT_URL } from '../../../../services/constants';

export default function getPopupUrl() {
  const url = `${AUTH_POPUP_BASE}/sso?client_id=${AUTH_CLIENT_ID}&scope=user-global&redirect_uri=${encodeURIComponent(
    AUTH_REDIRECT_URL,
  )}`;

  return url;
}
